var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"color":"inherit","font-family":"imagine"}},[_vm._v("\n  "+_vm._s(_vm.showTxt)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/tools/random-number.vue?vue&type=template&id=b750abca&scoped=true
// module id = null
// module chunks = 